<template>
  <section class="bg-white dark:bg-gray-900">
    <div class="lg:py-16 px-4 mx-auto max-w-screen-md text-center">
      <img src="@/assets/img/logo.png" alt="총회교육개발원" class="mx-auto mb-4"/>
      <p class="font-medium mb-2 text-[4vw] break-keep">{{ conf_detail.title }}</p>
      <p class="font-medium mb-2 text-[4vw] break-keep"> {{dept}} </p>
      <p class="mb-10 text-[4vw] break-keep" v-if="roomName"> 배정강의실 : <span class="font-medium">{{roomName}}</span> </p>

      <vue3-barcode :value="theValue" :height="50" v-if="is_reg" class="flex justify-center"/>

      <div v-if="conf_idx==3">

        <!-- 광주 -->
        <div v-if="number === 1">
          <div class="mt-12">
            <div class="conf_info text-left">
              <div class="conf_info_tt">장소</div>
              <p class="font-medium">광주동명교회 비전홀</p>
              <p>광주광역시 동구 동명로 20번길 31</p>
            </div>
            <div class="conf_info text-left">
              <div class="conf_info_tt">시간표</div>
              <p class="mb-2">18:00-19:00 <span class="ml-2">접수 및 자료 전시</span></p>
              <p class="mb-2">19:00-19:30 <span class="ml-2">예배</span></p>
              <p class="mb-2">19:30-19:45 <span class="ml-2">홍보영상 및 찬양 배우기</span></p>
              <p class="mb-2">19:45-20:00 <span class="ml-2">바른 신앙 캠페인 및 하나 바이블 주제 소개</span></p>
              <p class="mb-2">20:00-21:00 <span class="ml-2">교리 교육과정 특강</span></p>
              <p class="mb-2">21:00-22:00 <span class="ml-2">부서별 강의</span></p>
            </div>
            <div class="conf_info text-left">
              <div class="conf_info_tt">강의실 안내</div>
              <p class="mb-2">영유아부 - <b>영유아부실(1층)</b></p>
              <p class="mb-2">유치부 - <b>유치부실(1층)</b></p>
              <p class="mb-2">유년부 - <b>새가족부실(2층)</b></p>
              <p class="mb-2">초등부 - <b>비전홀(1층)</b></p>
              <p class="mb-2">청소년부 - <b>세미나실(3층)</b></p>
              <p class="mb-2">대학청년부 - <b>영상예배실(1층)</b></p>
              <p class="mb-2">장년,구역 - <b>찬양대실(2층)</b></p>
            </div>
          </div>
        </div>

        <!-- 대구 -->
        <div v-if="number === 2">
          <div class="mt-12">
            <div class="conf_info text-left">
              <div class="conf_info_tt">장소</div>
              <p class="font-medium">범어교회 갈릴리 채플</p>
              <p>대구광역시 수성구 청호로 84길 71</p>
            </div>
            <div class="conf_info text-left">
              <div class="conf_info_tt">시간표</div>
              <p class="mb-2">18:00-19:00 <span class="ml-2">접수 및 자료 전시</span></p>
              <p class="mb-2">19:00-19:30 <span class="ml-2">예배</span></p>
              <p class="mb-2">19:30-19:45 <span class="ml-2">홍보영상 및 찬양 배우기</span></p>
              <p class="mb-2">19:45-20:00 <span class="ml-2">바른 신앙 캠페인 및 하나 바이블 주제 소개</span></p>
              <p class="mb-2">20:00-21:00 <span class="ml-2">교리 교육과정 특강</span></p>
              <p class="mb-2">21:00-22:00 <span class="ml-2">부서별 강의</span></p>
            </div>
            <div class="conf_info text-left">
              <div class="conf_info_tt">강의실 안내</div>
              <p class="mb-2">영유아부 - 나사렛 <b>102</b>호 (지하 1층)</p>
              <p class="mb-2">유치부 - 나사렛 <b>101</b>호 (지하 1층)</p>
              <p class="mb-2">유년부 - 나사렛 <b>104</b>호 (지하 1층)</p>
              <p class="mb-2">초등부 - 나사렛 <b>100</b>호 (지상 1층)</p>
              <p class="mb-2">청소년부 - 나사렛 <b>102</b>호 (지상 2층)</p>
              <p class="mb-2">대학청년부 - 나사렛 <b>107</b>호 (지하 1층)</p>
              <p class="mb-2">장년,구역 - 갈릴리 <b>101</b>호 (지하 1층)</p>
            </div>
          </div>
        </div>

        <!-- 서울 -->
        <div v-if="number === 3">
          <div class="mt-12">
            <div class="conf_info text-left">
              <div class="conf_info_tt">장소</div>
              <p class="font-medium">왕십리교회 벧엘홀</p>
              <p>서울특별시 성동구 난계로 160(상왕십리동)</p>
            </div>
            <div class="conf_info text-left">
              <div class="conf_info_tt">시간표</div>
              <p class="mb-2">09:00-10:00 <span class="ml-2">접수 및 자료 전시</span></p>
              <p class="mb-2">10:00-10:30 <span class="ml-2">예배</span></p>
              <p class="mb-2">10:30-10:45 <span class="ml-2">홍보영상 및 찬양 배우기</span></p>
              <p class="mb-2">10:45-11:00 <span class="ml-2">바른 신앙 캠페인 및 하나 바이블 주제 소개</span></p>
              <p class="mb-2">11:00-12:00 <span class="ml-2">교리 교육과정 특강</span></p>
              <p class="mb-2">12:00-13:00 <span class="ml-2">부서별 강의</span></p>
            </div>
            <div class="conf_info text-left">
              <div class="conf_info_tt">강의실 안내</div>
              <p class="mb-2">영유아부 - <b>솔로몬홀 (3층)</b></p>
              <p class="mb-2">유치부 - <b>다니엘홀 (4층)</b></p>
              <p class="mb-2">유년부 - <b>요셉홀 (지하 2층)</b></p>
              <p class="mb-2">초등부 - <b>다윗홀 (지하 2층)</b></p>
              <p class="mb-2">청소년부 - <b>그리심홀 (8층)</b></p>
              <p class="mb-2">대학청년부 - <b>사무엘홀 (3층)</b></p>
              <p class="mb-2">장년,구역 - <b>마태홀 (지하 2층)</b></p>

            </div>
          </div>
        </div>



      </div>

    </div>
  </section>
</template>

<script>
import axios from "axios";
import { useRoute, useRouter } from 'vue-router'
import Vue3Barcode from 'vue3-barcode'


export default {
    name: "barcodeComponent",

    components: {
        Vue3Barcode
    },
    data() {
        return {
            theValue : "",
            is_reg : false,
            conf_detail : {},
            local: "",
            number: 0,
            dept: "",
            roomName: "",
            conf_idx : 0
        }
    },

    methods: {
        init(){
            axios.get('/api/register/conference/barcode/' + this.theValue).then(response => {
                const data = response.data;
                if(data.err_code==0 || data.err_code==100){
                    this.is_reg = true;
                    this.conf_detail = data.conferenceDetail.conference;
                    this.local = data.conferenceDetail.local;
                    this.number = data.conferenceDetail.number;
                    this.dept = data.conferenceDetail.dept;
                    this.roomName = data.registerConference.roomname;
                    this.conf_idx = data.registerConference.conferenceIdx;
                }else{
                    alert(data.err_msg);
                }
                
            }).catch(error => {
                console.error(error)
            })
        },
    },
    mounted() {
        const route = useRoute()
        this.theValue = route.params.idx;
        this.init();
        // console.log(this.theValue);
    }
}
</script>

<style scoped>
.conf_info {
  margin-bottom: 2.5rem;
}
.conf_info p {
  font-size: 4vw;
  padding: 0 0.5rem;
}
.conf_info_tt {
  background: #f2faff;
  border: 1px solid #039dff;
  color: #039dff;
  text-align: center;
  font-size: 4.25vw;
  font-weight: 500;
  margin-bottom: 0.5rem;
  padding: 0.5rem 1rem;
}

b {
  font-weight: 500;
}
</style>